/** Razorpay merchant dashboard deep links (logged-in staff). */
export function razorpayDashboardUrl(id) {
  const token = String(id || '').trim();
  if (!token) return null;
  if (token.startsWith('pay_')) {
    return `https://dashboard.razorpay.com/app/payments/${encodeURIComponent(token)}`;
  }
  if (token.startsWith('order_')) {
    return `https://dashboard.razorpay.com/app/orders/${encodeURIComponent(token)}`;
  }
  if (token.startsWith('plink_')) {
    return `https://dashboard.razorpay.com/app/payment_links/${encodeURIComponent(token)}`;
  }
  return null;
}

export function extractRazorpayToken(text) {
  const s = String(text || '').trim();
  if (!s) return null;
  const m = s.match(/\b(pay_[A-Za-z0-9]+|order_[A-Za-z0-9]+|plink_[A-Za-z0-9]+)\b/);
  return m ? m[1] : null;
}
